/* ============================================================
   DS Cart-Drawer Helpers — R9-H3-BLOCKER-Fix
   Built: 2026-05-27 nach R9-Audit
   Mission: window.dsOpenCartDrawer als programmatic API exposen
   damit Bundle-Pilot (ds-bundle.js Z.167-173) Cart-Drawer
   nach ATC öffnen kann. Ohne diesen Helper wäre Bundle-Cart-Add
   = Conversion-Killer (User sieht Toast aber kein Cart-Beleg).
   ============================================================ */

(function() {
  'use strict';

  function findCartDrawerTrigger() {
    // Theme-Pattern: js-drawer-open-cart, ds-cart-bar Button, oder data-drawer-toggle
    var selectors = [
      '.js-drawer-open-cart',
      '[data-drawer-toggle="cart"]',
      '#DsCartBar button',
      '.site-nav__link--cart',
      'a[href="/cart"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function openCartDrawer() {
    // Strategy 1: Click trigger (Snowdog-Drawer-Pattern)
    var trigger = findCartDrawerTrigger();
    if (trigger) {
      trigger.click();
      return true;
    }

    // Strategy 2: Theme.Drawers global toggle (legacy fallback)
    if (window.theme && window.theme.drawerCart && typeof window.theme.drawerCart.open === 'function') {
      window.theme.drawerCart.open();
      return true;
    }

    // Strategy 3: CustomEvent for theme-listeners
    document.dispatchEvent(new CustomEvent('cart:open', { detail: { source: 'ds-helpers' } }));

    // Strategy 4: body class fallback (Snowdog sn-cart-open pattern)
    document.body.classList.add('sn-cart-open');

    return false;
  }

  function closeCartDrawer() {
    var closer = document.querySelector('.js-drawer-close, [data-drawer-close]');
    if (closer) {
      closer.click();
      return true;
    }
    document.body.classList.remove('sn-cart-open', 'js-drawer-open');
    return false;
  }

  // Expose globally for Bundle-Pilot + future modules
  window.dsOpenCartDrawer = openCartDrawer;
  window.dsCloseCartDrawer = closeCartDrawer;

  // Auto-Listener für cart:bundle-added Event (Bundle-Pilot Fallback-Path)
  document.addEventListener('cart:bundle-added', function() {
    openCartDrawer();
  });

  if (window.DS_DEBUG) {
    console.info('[DS-Cart-Drawer-Helpers] Loaded. window.dsOpenCartDrawer + dsCloseCartDrawer + cart:bundle-added Listener bereit.');
  }

})();
